/* KOPFHÖHE MESSEN — für alle Seiten, die den Miravello-Rahmen tragen.
 *
 * Der Ankündigungsbalken ist ein Lauftext, seine Höhe hängt von Schriftgrösse
 * und Zeilenumbruch ab, er lässt sich abschalten, und beim Drehen des Geräts
 * kommt ein anderer Wert heraus. Eine feste Zahl ist beim nächsten Gerät
 * wieder falsch — deshalb wird gemessen.
 *
 * Zwei Stellen brauchen den Wert:
 *   1. Das Warenkorb-Panel der Produktseite (--kopf-hoehe als oberer Abstand;
 *      ohne ihn lag die erste Zeile unter der Kopfzeile, siehe Auftrag 16).
 *   2. Die Warenkorbseite, deren Inhalt unter dem festen Rahmen beginnt.
 *
 * Diese Datei ist die eine Quelle. mv-produkt.js ruft sie auf, wenn sie da
 * ist, und misst nur selbst, wenn nicht.
 */
(function () {
  "use strict";

  var doc = document;

  function klebtOben(el) {
    if (!el) return false;
    var s = getComputedStyle(el);
    if (s.display === "none" || s.visibility === "hidden") return false;
    /* Nur was wirklich stehen bleibt, verdeckt etwas. Scrollt die Kopfzeile
       mit, deckt sie nichts ab. */
    if (s.position !== "fixed" && s.position !== "sticky") return false;
    return el.getBoundingClientRect().height > 0;
  }

  function messen() {
    var unten = 0;
    [doc.querySelector(".ticker"), doc.querySelector(".nav")].forEach(function (el) {
      if (!klebtOben(el)) return;
      unten = Math.max(unten, el.getBoundingClientRect().bottom);
    });
    doc.documentElement.style.setProperty("--kopf-hoehe", Math.max(0, Math.round(unten)) + "px");
    return unten;
  }

  window.mvKopfhoehe = messen;

  messen();
  addEventListener("resize", messen);
  addEventListener("orientationchange", messen);
  /* Ein ResizeObserver fängt auch, was kein resize-Ereignis auslöst: der
     Balken wird abgeschaltet, oder die Kopfzeile wechselt beim Scrollen in
     ihren kompakteren Zustand (.nav.is-solid hat weniger Innenabstand). */
  if (window.ResizeObserver) {
    var beobachter = new ResizeObserver(messen);
    [doc.querySelector(".ticker"), doc.querySelector(".nav")].forEach(function (el) {
      if (el) beobachter.observe(el);
    });
  }
})();
